/**
 * Labstep
 *
 * @module components/ResourceItem/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete as DeleteAction } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { IResourceItemActionDeleteProps } from './types';

export const ResourceItemActionDelete: React.FC<
  IResourceItemActionDeleteProps
> = ({ resourceItem, ...rest }) => (
  <DeleteAction {...rest} entity={resourceItem} />
);
